(function () {
  'use strict';

  // ─── Config ──────────────────────────────────────────────────────────────────
  const WORKER_URL = 'https://nsp-agent.nsp-agent-nsp.workers.dev';
  const BRAND_CREAM = '#F2CEA2';
  const BRAND_DARK = '#1a1a1a';

  // ─── Session ─────────────────────────────────────────────────────────────────
  function getSessionId() {
    let id = sessionStorage.getItem('nsp_sid');
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem('nsp_sid', id);
    }
    return id;
  }

  function getPreChatData() {
    return {
      name: sessionStorage.getItem('nsp_name') || '',
      email: sessionStorage.getItem('nsp_email') || '',
    };
  }

  function savePreChatData(name, email) {
    if (name) sessionStorage.setItem('nsp_name', name);
    if (email) sessionStorage.setItem('nsp_email', email);
  }

  // ─── Styles ──────────────────────────────────────────────────────────────────
  const CSS = `
    #nsp-chat-root *, #nsp-chat-root *::before, #nsp-chat-root *::after {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }
    #nsp-chat-root {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      font-size: 15px;
      line-height: 1.5;
      color: ${BRAND_DARK};
    }

    /* Bubble wrapper */
    #nsp-chat-bubble-wrap {
      position: fixed;
      bottom: 24px;
      right: 24px;
      display: flex;
      align-items: center;
      gap: 10px;
      z-index: 99998;
      flex-direction: row-reverse;
    }

    /* Tooltip pill */
    #nsp-chat-tooltip {
      background: ${BRAND_DARK};
      color: ${BRAND_CREAM};
      font-size: 13px;
      font-weight: 500;
      padding: 8px 14px;
      border-radius: 20px;
      white-space: nowrap;
      box-shadow: 0 4px 14px rgba(0,0,0,0.2);
      opacity: 0;
      transform: translateX(8px);
      transition: opacity 0.3s ease, transform 0.3s ease;
      pointer-events: none;
      cursor: pointer;
    }
    #nsp-chat-tooltip.nsp-tooltip-show {
      opacity: 1;
      transform: translateX(0);
      pointer-events: all;
    }

    /* Bubble */
    #nsp-chat-bubble {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background: ${BRAND_DARK};
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 16px rgba(0,0,0,0.25);
      flex-shrink: 0;
      transition: transform 0.2s ease, box-shadow 0.2s ease;
      overflow: hidden;
      padding: 0;
    }
    #nsp-chat-bubble:hover {
      transform: scale(1.07);
      box-shadow: 0 6px 20px rgba(0,0,0,0.3);
    }
    #nsp-chat-bubble svg {
      width: 56px;
      height: 56px;
    }

    /* Panel */
    #nsp-chat-panel {
      position: fixed;
      bottom: 92px;
      right: 24px;
      width: 360px;
      max-height: 560px;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 8px 40px rgba(0,0,0,0.18);
      display: flex;
      flex-direction: column;
      overflow: hidden;
      z-index: 99999;
      opacity: 0;
      transform: translateY(12px) scale(0.97);
      transition: opacity 0.22s ease, transform 0.22s ease;
      pointer-events: none;
    }
    #nsp-chat-panel.nsp-open {
      opacity: 1;
      transform: translateY(0) scale(1);
      pointer-events: all;
    }

    /* Header */
    #nsp-chat-header {
      background: ${BRAND_DARK};
      color: ${BRAND_CREAM};
      padding: 14px 16px;
      display: flex;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
    }
    #nsp-chat-header-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      flex-shrink: 0;
      border: 2px solid rgba(242,206,162,0.4);
    }
    #nsp-chat-header-avatar svg {
      width: 40px;
      height: 40px;
      display: block;
    }
    #nsp-chat-header-text {
      flex: 1;
    }
    #nsp-chat-header-title {
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.02em;
    }
    #nsp-chat-header-sub {
      font-size: 12px;
      opacity: 0.7;
      margin-top: 1px;
    }
    #nsp-chat-close {
      background: none;
      border: none;
      cursor: pointer;
      color: ${BRAND_CREAM};
      opacity: 0.7;
      padding: 4px;
      display: flex;
      align-items: center;
      transition: opacity 0.15s;
    }
    #nsp-chat-close:hover { opacity: 1; }
    #nsp-chat-close svg { width: 18px; height: 18px; fill: currentColor; }

    /* Pre-chat form */
    #nsp-prechat {
      padding: 20px 16px;
      flex: 1;
      overflow-y: auto;
    }
    #nsp-prechat-intro {
      font-size: 14px;
      color: #555;
      margin-bottom: 16px;
      line-height: 1.5;
    }
    .nsp-field {
      margin-bottom: 12px;
    }
    .nsp-field label {
      display: block;
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: #888;
      margin-bottom: 4px;
    }
    .nsp-field input {
      width: 100%;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 9px 12px;
      font-size: 14px;
      outline: none;
      transition: border-color 0.15s;
    }
    .nsp-field input:focus { border-color: ${BRAND_DARK}; }
    .nsp-btn-primary {
      width: 100%;
      background: ${BRAND_DARK};
      color: ${BRAND_CREAM};
      border: none;
      border-radius: 8px;
      padding: 11px 16px;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
      margin-top: 4px;
      transition: opacity 0.15s;
    }
    .nsp-btn-primary:hover { opacity: 0.85; }

    /* Messages */
    #nsp-messages {
      flex: 1;
      overflow-y: auto;
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      scroll-behavior: smooth;
    }
    .nsp-msg {
      max-width: 85%;
      padding: 10px 13px;
      border-radius: 12px;
      font-size: 14px;
      line-height: 1.5;
      word-break: break-word;
    }
    .nsp-msg-user {
      align-self: flex-end;
      background: ${BRAND_CREAM};
      color: ${BRAND_DARK};
      border-bottom-right-radius: 3px;
    }
    .nsp-msg-assistant {
      align-self: flex-start;
      background: #f4f4f4;
      color: ${BRAND_DARK};
      border-bottom-left-radius: 3px;
    }
    .nsp-msg-assistant a {
      color: ${BRAND_DARK};
      text-decoration: underline;
    }
    .nsp-typing {
      align-self: flex-start;
      padding: 12px 16px;
      background: #f4f4f4;
      border-radius: 12px;
      border-bottom-left-radius: 3px;
      display: flex;
      gap: 5px;
      align-items: center;
    }
    .nsp-typing span {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #bbb;
      display: inline-block;
      animation: nsp-bounce 1.2s infinite ease-in-out;
    }
    .nsp-typing span:nth-child(2) { animation-delay: 0.2s; }
    .nsp-typing span:nth-child(3) { animation-delay: 0.4s; }
    @keyframes nsp-bounce {
      0%, 60%, 100% { transform: translateY(0); }
      30% { transform: translateY(-6px); }
    }

    /* Input area */
    #nsp-input-area {
      border-top: 1px solid #f0f0f0;
      padding: 10px 12px;
      display: flex;
      gap: 8px;
      align-items: flex-end;
      flex-shrink: 0;
    }
    #nsp-input {
      flex: 1;
      border: 1px solid #e0e0e0;
      border-radius: 10px;
      padding: 9px 12px;
      font-size: 14px;
      resize: none;
      outline: none;
      max-height: 100px;
      overflow-y: auto;
      line-height: 1.4;
      transition: border-color 0.15s;
      font-family: inherit;
    }
    #nsp-input:focus { border-color: ${BRAND_DARK}; }
    #nsp-send {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      background: ${BRAND_DARK};
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      transition: opacity 0.15s;
    }
    #nsp-send:hover { opacity: 0.8; }
    #nsp-send:disabled { opacity: 0.4; cursor: default; }
    #nsp-send svg { width: 16px; height: 16px; fill: ${BRAND_CREAM}; }

    /* Product cards */
    .nsp-product-cards {
      align-self: flex-start;
      display: flex;
      flex-direction: column;
      gap: 8px;
      width: 85%;
    }
    .nsp-product-card {
      display: flex;
      align-items: center;
      gap: 10px;
      background: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 10px;
      padding: 8px 10px;
      text-decoration: none;
      color: inherit;
      transition: background 0.15s, border-color 0.15s;
      cursor: pointer;
    }
    .nsp-product-card:hover {
      background: #fafafa;
      border-color: #ccc;
    }
    .nsp-product-card-img {
      width: 52px;
      height: 52px;
      border-radius: 7px;
      object-fit: cover;
      flex-shrink: 0;
      background: #f4f4f4;
    }
    .nsp-product-card-info {
      flex: 1;
      min-width: 0;
    }
    .nsp-product-card-name {
      font-weight: 600;
      font-size: 12px;
      color: ${BRAND_DARK};
      line-height: 1.3;
    }
    .nsp-product-card-price {
      font-size: 12px;
      color: #888;
      margin-top: 2px;
    }
    .nsp-product-card-btn {
      background: ${BRAND_DARK};
      color: ${BRAND_CREAM};
      font-size: 11px;
      font-weight: 600;
      padding: 5px 10px;
      border-radius: 6px;
      white-space: nowrap;
      flex-shrink: 0;
    }

    /* Powered-by footer */
    #nsp-powered {
      text-align: center;
      font-size: 11px;
      color: #ccc;
      padding: 6px 0 8px;
      flex-shrink: 0;
    }

    /* Mobile */
    @media (max-width: 420px) {
      #nsp-chat-panel {
        bottom: 0;
        right: 0;
        left: 0;
        width: 100%;
        max-height: 85vh;
        border-radius: 16px 16px 0 0;
      }
      #nsp-chat-bubble {
        bottom: 16px;
        right: 16px;
      }
    }
  `;

  // ─── SVG Icons ───────────────────────────────────────────────────────────────
  const ICON_SEND = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2 21 23 12 2 3v7l15 2-15 2v7Z" fill="${BRAND_CREAM}"/></svg>`;
  const ICON_CLOSE = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18 6 6 18M6 6l12 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"/></svg>`;

  const LOGO_B64 = 'data:image/png;base64,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';

  const LOGO_IMG_BUBBLE = `<img src="${LOGO_B64}" alt="Nous Sommes Pure" style="width:56px;height:56px;object-fit:cover;display:block;">`;
  const LOGO_IMG_HEADER = `<img src="${LOGO_B64}" alt="Nous Sommes Pure" style="width:40px;height:40px;object-fit:cover;display:block;">`;

  // ─── Product catalogue ───────────────────────────────────────────────────────
  const PRODUCTS = {
    humide: {
      name: 'HUMIDE™ Daily Hydration Mist',
      price: '£13.99',
      url: '/products/humide',
      img: 'https://cdn.shopify.com/s/files/1/0854/7549/2188/files/hf_20260705_133759_a0e31ff2-14e2-467e-900e-a64e3cd00c71.png?v=1783261758',
    },
    lavie: {
      name: "LA'VIE™ Daily Moisturising Cream",
      price: '£17.99',
      url: '/products/lavie-moisturizing-cream-250ml',
      img: 'https://cdn.shopify.com/s/files/1/0854/7549/2188/files/hf_20260705_112838_3c3e6583-84a2-4fae-b004-d4ea79526dfe.png?v=1783254681',
    },
    dor: {
      name: "D'OR™ Botanical Hair & Scalp Oil",
      price: '£23.99',
      url: '/products/dor-hair-growth-serum',
      img: 'https://cdn.shopify.com/s/files/1/0854/7549/2188/files/hf_20260705_150315_d9077a6b-a7f8-463a-adf5-ad3bf6da4533.png?v=1783265028',
    },
    luxe: {
      name: 'LUXE™ Botanical Scalp Treatment',
      price: '£21.99',
      url: '/products/luxe-ayurverdic-hair-grease',
      img: 'https://cdn.shopify.com/s/files/1/0854/7549/2188/files/hf_20260705_125216_4cccfc3b-a235-4f9e-8977-7138bb71ad96.png?v=1783256872',
    },
    vitalite: {
      name: 'Vitalité Bundle',
      price: '£69.99',
      url: '/products/vitalite-bundle',
      img: 'https://cdn.shopify.com/s/files/1/0854/7549/2188/files/jhjh.webp?v=1783278255',
    },
    'le-rituel': {
      name: 'Le Rituel Bundle',
      price: '£49.99',
      url: '/products/le-rituel',
      img: 'https://cdn.shopify.com/s/files/1/0854/7549/2188/files/hf_20260711_124823_4135dd70-669c-414b-8a91-b43060c4de6f.png?v=1783774359',
    },
  };

  // ─── State ───────────────────────────────────────────────────────────────────
  let isOpen = false;
  let preChatDone = false;
  let sending = false;

  // ─── DOM ─────────────────────────────────────────────────────────────────────
  function buildWidget() {
    // Inject styles
    const style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    // Root
    const root = document.createElement('div');
    root.id = 'nsp-chat-root';
    document.body.appendChild(root);

    // Bubble wrapper
    const bubbleWrap = document.createElement('div');
    bubbleWrap.id = 'nsp-chat-bubble-wrap';
    root.appendChild(bubbleWrap);

    // Tooltip
    const tooltip = document.createElement('div');
    tooltip.id = 'nsp-chat-tooltip';
    tooltip.textContent = 'How can we help you today?';
    bubbleWrap.appendChild(tooltip);

    // Bubble
    const bubble = document.createElement('button');
    bubble.id = 'nsp-chat-bubble';
    bubble.setAttribute('aria-label', 'Open chat');
    bubble.innerHTML = LOGO_IMG_BUBBLE;
    bubbleWrap.appendChild(bubble);

    // Show tooltip after 3s if panel not open
    setTimeout(() => {
      if (!isOpen) tooltip.classList.add('nsp-tooltip-show');
    }, 3000);
    // Hide tooltip when panel opens
    bubble.addEventListener('click', () => tooltip.classList.remove('nsp-tooltip-show'));
    tooltip.addEventListener('click', () => {
      tooltip.classList.remove('nsp-tooltip-show');
      togglePanel(panel);
    });

    // Panel
    const panel = document.createElement('div');
    panel.id = 'nsp-chat-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'NSP hair adviser chat');
    root.appendChild(panel);

    // Header
    panel.innerHTML = `
      <div id="nsp-chat-header">
        <div id="nsp-chat-header-avatar">${LOGO_IMG_HEADER}</div>
        <div id="nsp-chat-header-text">
          <div id="nsp-chat-header-title">Nous Sommes Pure</div>
          <div id="nsp-chat-header-sub">Hair Adviser — ask me anything</div>
        </div>
        <button id="nsp-chat-close" aria-label="Close chat">${ICON_CLOSE}</button>
      </div>
      <div id="nsp-prechat">
        <p id="nsp-prechat-intro">Hey! Drop your details below and I'll help you find exactly what your hair needs.</p>
        <div class="nsp-field">
          <label for="nsp-field-name">Your name</label>
          <input type="text" id="nsp-field-name" placeholder="e.g. Amara" autocomplete="given-name">
        </div>
        <div class="nsp-field">
          <label for="nsp-field-email">Email address</label>
          <input type="email" id="nsp-field-email" placeholder="your@email.com" autocomplete="email" required>
        </div>
        <button class="nsp-btn-primary" id="nsp-prechat-start">Let's go</button>
      </div>
      <div id="nsp-messages" style="display:none" role="log" aria-live="polite"></div>
      <div id="nsp-input-area" style="display:none">
        <textarea id="nsp-input" rows="1" placeholder="Ask about your hair…" maxlength="2000" aria-label="Chat message"></textarea>
        <button id="nsp-send" aria-label="Send message">${ICON_SEND}</button>
      </div>
      <div id="nsp-powered" style="display:none">Powered by Nous Sommes Pure</div>
    `;

    bindEvents(root, panel);
  }

  function bindEvents(root, panel) {
    const bubble = root.querySelector('#nsp-chat-bubble');
    const close = panel.querySelector('#nsp-chat-close');
    const startBtn = panel.querySelector('#nsp-prechat-start');
    const sendBtn = panel.querySelector('#nsp-send');
    const input = panel.querySelector('#nsp-input');

    bubble.addEventListener('click', () => togglePanel(panel));
    close.addEventListener('click', () => closePanel(panel));

    startBtn.addEventListener('click', () => {
      const name = panel.querySelector('#nsp-field-name').value.trim();
      const email = panel.querySelector('#nsp-field-email').value.trim();
      const emailInput = panel.querySelector('#nsp-field-email');
      if (!email || !email.includes('@')) {
        emailInput.style.borderColor = '#c0392b';
        emailInput.focus();
        return;
      }
      emailInput.style.borderColor = '';
      savePreChatData(name, email);
      startChat(panel, name);
    });

    panel.querySelector('#nsp-field-name').addEventListener('keydown', (e) => {
      if (e.key === 'Enter') panel.querySelector('#nsp-field-email').focus();
    });
    panel.querySelector('#nsp-field-email').addEventListener('keydown', (e) => {
      if (e.key === 'Enter') startBtn.click();
    });

    sendBtn.addEventListener('click', () => sendMessage(panel));
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendMessage(panel);
      }
    });
    input.addEventListener('input', () => autoResize(input));
  }

  function togglePanel(panel) {
    isOpen = !isOpen;
    panel.classList.toggle('nsp-open', isOpen);
    if (isOpen && !preChatDone) {
      setTimeout(() => panel.querySelector('#nsp-field-name').focus(), 250);
    } else if (isOpen) {
      setTimeout(() => panel.querySelector('#nsp-input').focus(), 250);
    }
  }

  function closePanel(panel) {
    isOpen = false;
    panel.classList.remove('nsp-open');
  }

  function startChat(panel, name) {
    preChatDone = true;
    panel.querySelector('#nsp-prechat').style.display = 'none';
    panel.querySelector('#nsp-messages').style.display = 'flex';
    panel.querySelector('#nsp-input-area').style.display = 'flex';
    panel.querySelector('#nsp-powered').style.display = 'block';

    const greeting = name
      ? `Hi ${name}! I'm your NSP hair adviser. Tell me about your hair — what's your main concern right now?`
      : `Hi! I'm your NSP hair adviser. Tell me about your hair — what's your main concern right now?`;
    appendMessage(panel, 'assistant', greeting);

    setTimeout(() => panel.querySelector('#nsp-input').focus(), 50);
  }

  async function sendMessage(panel) {
    if (sending) return;
    const input = panel.querySelector('#nsp-input');
    const text = input.value.trim();
    if (!text) return;

    input.value = '';
    autoResize(input);
    setSending(panel, true);
    appendMessage(panel, 'user', text);
    const typing = showTyping(panel);

    const { name, email } = getPreChatData();

    try {
      const res = await fetch(WORKER_URL + '/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId: getSessionId(),
          message: text,
          name: name || undefined,
          email: email || undefined,
        }),
      });

      const data = await res.json();
      removeTyping(typing);

      if (!res.ok) {
        appendMessage(panel, 'assistant', "Sorry, I couldn't get a response right now. Please try again in a moment.");
      } else {
        appendMessage(panel, 'assistant', data.reply);
        if (data.products && data.products.length) {
          appendProductCards(panel, data.products);
        }
        if (data.capped) {
          disableInput(panel);
        }
      }
    } catch {
      removeTyping(typing);
      appendMessage(panel, 'assistant', "Something went wrong on my end. Please try again.");
    }

    setSending(panel, false);
    scrollToBottom(panel);
  }

  function renderAssistantText(text) {
    return text
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  }

  function appendMessage(panel, role, text) {
    const messages = panel.querySelector('#nsp-messages');
    const msg = document.createElement('div');
    msg.className = `nsp-msg nsp-msg-${role}`;
    if (role === 'assistant') {
      msg.innerHTML = renderAssistantText(text);
    } else {
      msg.textContent = text;
    }
    messages.appendChild(msg);
    scrollToBottom(panel);
  }

  function showTyping(panel) {
    const messages = panel.querySelector('#nsp-messages');
    const el = document.createElement('div');
    el.className = 'nsp-typing';
    el.innerHTML = '<span></span><span></span><span></span>';
    messages.appendChild(el);
    scrollToBottom(panel);
    return el;
  }

  function removeTyping(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function setSending(panel, state) {
    sending = state;
    const send = panel.querySelector('#nsp-send');
    const input = panel.querySelector('#nsp-input');
    send.disabled = state;
    input.disabled = state;
  }

  function disableInput(panel) {
    const area = panel.querySelector('#nsp-input-area');
    area.style.display = 'none';
    const note = document.createElement('p');
    note.style.cssText = 'text-align:center;font-size:13px;color:#aaa;padding:10px 16px 14px;';
    note.textContent = 'This chat has ended. Start a new session to continue.';
    panel.querySelector('#nsp-powered').insertAdjacentElement('beforebegin', note);
  }

  function appendProductCards(panel, keys) {
    const messages = panel.querySelector('#nsp-messages');
    const wrap = document.createElement('div');
    wrap.className = 'nsp-product-cards';
    keys.forEach((key) => {
      const p = PRODUCTS[key];
      if (!p) return;
      const card = document.createElement('a');
      card.className = 'nsp-product-card';
      card.href = p.url;
      card.target = '_blank';
      card.rel = 'noopener noreferrer';
      card.innerHTML =
        `<img class="nsp-product-card-img" src="${p.img}" alt="${p.name}" loading="lazy">` +
        `<div class="nsp-product-card-info">` +
        `<div class="nsp-product-card-name">${p.name}</div>` +
        `<div class="nsp-product-card-price">${p.price}</div>` +
        `</div>` +
        `<span class="nsp-product-card-btn">Shop Now</span>`;
      wrap.appendChild(card);
    });
    messages.appendChild(wrap);
    scrollToBottom(panel);
  }

  function scrollToBottom(panel) {
    const messages = panel.querySelector('#nsp-messages');
    messages.scrollTop = messages.scrollHeight;
  }

  function autoResize(textarea) {
    textarea.style.height = 'auto';
    textarea.style.height = Math.min(textarea.scrollHeight, 100) + 'px';
  }

  // ─── Init ─────────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildWidget);
  } else {
    buildWidget();
  }
})();
